import { DistributionActionTypes, DistributionState } from './distributionTypes';

const INIT_STATE: DistributionState = {
  packId: null,
  angle: null,
  outputs: {},
  activeFormat: 'linkedin',
  copiedFormat: null,
  feedback: {},
  isLoading: false,
  error: null,
};

const distributionReducer = (state = INIT_STATE, action: any): DistributionState => {
  switch (action.type) {

    case DistributionActionTypes.GENERATE:
      return { ...state, isLoading: true, error: null };

    case DistributionActionTypes.SET_ACTIVE_FORMAT:
      return { ...state, activeFormat: action.payload.format };

    case DistributionActionTypes.SET_COPIED:
      return { ...state, copiedFormat: action.payload.format };

    case DistributionActionTypes.SET_FEEDBACK:
      return {
        ...state,
        feedback: { ...state.feedback, [action.payload.format]: action.payload.vote },
      };

    case DistributionActionTypes.SET_PACK_ID:
      return { ...state, packId: action.payload.packId };

    case DistributionActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case DistributionActionTypes.GENERATE:
          return {
            ...state,
            outputs:      action.payload.data.outputs,
            angle:        action.payload.data.angle,
            packId:       null,    // assigned only after save
            copiedFormat: null,
            feedback:     {},
            activeFormat: 'linkedin',
            isLoading:    false,
            error:        null,
          };
        default:
          return state;
      }

    case DistributionActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case DistributionActionTypes.GENERATE:
          return { ...state, isLoading: false, error: action.payload.error };
        default:
          return state;
      }

    case DistributionActionTypes.RESET:
      return INIT_STATE;

    default:
      return state;
  }
};

export default distributionReducer;
